import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

export const beneficiaryClauseConfigurationFields: FieldInterface[] = [
  {
    key: 'beneficiaryClause',
    originKey: 'beneficiary_clause',
    type: FIELD_TYPES.string,
    isMultiple: true,
  },
  {
    key: 'clauseDependencies',
    originKey: 'clause_dependencies',
    type: FIELD_TYPES.object,
    objectType: 'ClauseDependencies',
    objectTypePath:
      'src/services/mappings/beneficiaryClauseConfiguration/beneficiaryClauseConfiguration.types',
  },
  {
    key: 'beneficiaryClauseLabels',
    originKey: 'beneficiary_clause_labels',
    type: FIELD_TYPES.object,
    objectType: 'BeneficiaryClausesLabels',
    objectTypePath:
      'src/services/mappings/beneficiaryClauseConfiguration/beneficiaryClauseConfiguration.types',
  },
  {
    key: 'clausesWithBeneficiaries',
    originKey: 'clauses_with_beneficiaries',
    type: FIELD_TYPES.string,
    isMultiple: true,
  },
]

export const beneficiaryClauseConfigurationRelations: RelationInterface[] = [
  {
    key: '_possibleBeneficiaries',
    originKey: 'possible_beneficiaries',
    objectType: OBJECT_TYPES.person,
    isMultiple: true,
  },
]
